import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/service-sitting.jpg")